window.addEventListener("DOMContentLoaded", function () {
  initProductFloatAddCart();

  function initProductFloatAddCart() {
    if (!customElements.get("product-float-add-cart")) {
      customElements.define(
        "product-float-add-cart",
        class ProductFloatAddCart extends HTMLElement {
          abortController = undefined;
          constructor() {
            super();
            this.position = this.getAttribute("data-position");
            this.pfac_mask = this.querySelector(".pfac_mask");
            this.pfac_float_btn = this.querySelector(".pfac_float_btn");
            this.pfac_content = this.querySelector(".pfac_content");
            this.pfac_close_btn = this.querySelector(".pfac_content_close");
            this.sectionId = $(this).parent("product-info").attr("data-section");
            this.productUrl = $(this).parent("product-info").attr("data-url");

            this.autoPlayTimer = null;
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.closeTimer = null;
            this.pfacSwiper = null; // 用于标题轮播
            this.prodSwiperInstance = null; // 【新增】用于记录商品图片轮播实例，方便后续更新销毁
          }

          connectedCallback() {
            const that = this;

            this.initScrollListener();
            this.initState();
            this.initContentPadding();
            this.initPopListener();
            this.initPopQuantity();
            this.initPopVariant();
            this.initBuyButtons();
            this.initPreviewImg();
            this.initProductSwiper();
            this.initTitleSwiper();

            // 订阅变量变化监听
            if (typeof subscribe === 'function') {
              subscribe(PUB_SUB_EVENTS.variantChange, function({data}){
                let option_values = Array.from($('.product__info-container > variant-selects').find("input[type='radio']:checked")).map(item => {
                  return $(item).attr('data-option-value-id');
                });

                function unique(arr) {
                  const result = [];
                  let hasNaN = false;
                  for (const item of arr) {
                    if (item !== item) { 
                      if (!hasNaN) {
                        result.push(item);
                        hasNaN = true;
                      }
                    } else {
                      let isDuplicate = false;
                      for (const res of result) {
                        if (item === res) {
                          isDuplicate = true;
                          break;
                        }
                      }
                      if (!isDuplicate) result.push(item);
                    }
                  }
                  return result;
                }

                that.renderPopContent(unique(option_values).join(','));
              });
            }
          }

          // 【修复】商品主图轮播初始化，支持重新挂载
          initProductSwiper(){
            const swiperEl = this.querySelector("#pfac-product-swiper");
            if (!swiperEl) return;
            
            // 如果之前有实例，先销毁，防止切换变体时内存泄漏或滑动失效
            if (this.prodSwiperInstance) {
              this.prodSwiperInstance.destroy(true, true);
            }
            this.prodSwiperInstance = new Swiper(swiperEl, {
              slidesPerView: 2.3, // 按照你的设定
              spaceBetween: 6
            });
          }

          // 【修复】大图预览点击事件
          initPreviewImg(){
            const that = this;
            $(this).find('.pafc_preview_img').on('click',function(e){
              e.stopPropagation();
              $(that).find('.pafc_preview_img').hide();
            });

            $(this).find('.pafc_preview_img img').on('click',function(e){
              e.stopPropagation();
            });

            // 将旧的 .pfac_content_info_img 替换为最新的图片容器 .pfac_image_slider
            $(this).find('.pfac_content').on('click', '.pfac_image_slider img', function(e){
              // 动态把点击的图片链接赋给预览大图（应对多图情况）
              const clickedSrc = $(this).attr('src');
              if(clickedSrc) {
                $(that).find('.pafc_preview_img .fpac_big_pro_img').attr('src', clickedSrc);
              }
              $(that).find('.pafc_preview_img').css("display","flex");
            });
          }

          initBuyButtons() {
            const that = this;
            // Add To Cart 事件
            $(that.pfac_content).on("click", ".pfac_add_to_cart", function (e) {
              e.stopPropagation();
              // 【修复】数量选择器类名变更为 .pfac_qty_input
              let num = $(that).find('.pfac_qty_input .pfac_num').text().trim();
              let id = $(that).find('.pfac_variant_pickers').attr('data-prod-id').trim();

              console.log("......add cart....");

              let data = {
                'id': id,
                'quantity': parseInt(num) || 1
              };

              if (that.cart) {
                data['sections'] = that.cart.getSectionsToRender().map((section) => section.id);
              }

              $.ajax({
                  type: 'POST',
                  url: "/cart/add.js",
                  data: data,
                  success: function(res){
                    console.log(res,'---12312--')
                    if (!(that.cart)) {
                      console.log("加购.....1......")
                      window.location = window.routes.cart_url || '/cart';
                      that.closePop();
                    } else {
                      that.closePop();
                      that.cart.renderContents(res);
                      if (that.cart && that.cart.classList.contains('is-empty')) that.cart.classList.remove('is-empty');
                    }
                  },
                  dataType: 'json'
              });
            });

            // Buy Now 事件
            $(that.pfac_content).on("click", ".pfac_buy_now", function (e) {
              e.stopPropagation();
              let num = $(that).find('.pfac_qty_input .pfac_num').text().trim();
              let id = $(that).find('.pfac_variant_pickers').attr('data-prod-id').trim();
              window.location.href=`/cart/add?id=${id}&quantity=${num}&return_to=/checkout`; // Shopify更标准的直接购买链接写法
              that.closePop();
            });
          }

          initTitleSwiper() {
            const that = this;
            if (Array.from($(this).find(".pfac_content_title_text")).length >= 1) {
              that.pfacSwiper = new Swiper(".pfac_swiper", {
                direction: "vertical",
                loop: true,
                autoplay: {
                  disableOnInteraction: false,
                  delay: 2500,
                }
              });
            }
          }

          initPopVariant() {
            const that = this;
            $(that.pfac_content).off("click", ".pfac_variant_item");
            $(that.pfac_content).on("click", ".pfac_variant_item", function () {
              if ($(this).hasClass("disabled")) {
                return false;
              }
              $(this)
                .addClass("pfac_active_variant")
                .siblings()
                .removeClass("pfac_active_variant");

              that.handleVariantChange();
            });
          }

          handleVariantChange() {
            const that = this;
            let option_values = [];
            let _activeVariant = $(that).find(".pfac_active_variant");
            Array.from(_activeVariant).forEach((item) => {
              option_values.push($(item).attr("data-option-value-id"));
            });

            that.renderPopContent(option_values.join(","));
            $(that).find(".pfac_buttons").addClass("disabled");
          }

          renderPopContent(option_values) {
            const that = this;
            this.abortController?.abort();
            this.abortController = new AbortController();
            let requestUrl = `${that.productUrl}?section_id=${that.sectionId}&option_values=${option_values}`;
            
            fetch(requestUrl, { signal: this.abortController.signal })
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, "text/html");
                that.updateNode(html);
              })
              .catch((error) => {
                if (error.name === "AbortError") {
                  console.log("Fetch aborted by user");
                } else {
                  console.error(error);
                }
              });
          }

          updateNode(newHtml) {
            const that = this;
            const oldRoot = this;
            const newRoot = newHtml;

            const parentElements = {
              ".pafc_preview_img": oldRoot.querySelector(".pafc_preview_img"),
              ".pfac_product_info_wrapper": oldRoot.querySelector(".pfac_product_info_wrapper"),
              ".pfac_footer": oldRoot.querySelector(".pfac_footer")
            };

            const updateQueue = [];

            [
              { selector: ".fpac_big_pro_img", parent: ".pafc_preview_img" },
              { selector: ".pfac_price_row", parent: ".pfac_product_info_wrapper" },
              { selector: ".pfac_variant_pickers", parent: ".pfac_product_info_wrapper" },
              { selector: ".pfac_buttons", parent: ".pfac_footer" }
            ].forEach(({ selector, parent }) => {
              const oldEl = oldRoot.querySelector(selector);
              const newEl = newRoot.querySelector(selector);
              const parentEl = parentElements[parent];

              if (oldEl && newEl && parentEl) {
                updateQueue.push(() => {
                  parentEl.replaceChild(_cloneWithState(newEl, oldEl), oldEl);
                });
              }
            });

            const oldSwiper = oldRoot.querySelector(".pfac_image_slider .swiper-wrapper");
            const newSwiper = newRoot.querySelector(".pfac_image_slider .swiper-wrapper");
            if (oldSwiper && newSwiper) {
              updateQueue.push(() => {
                oldSwiper.innerHTML = newSwiper.innerHTML;
              });
            }

            if (updateQueue.length > 0) {
              requestAnimationFrame(() => {
                updateQueue.forEach((update) => update());
                _bindDynamicEvents(oldRoot);
              });
            } else {
              _bindDynamicEvents(oldRoot);
            }

            function _cloneWithState(newEl, oldEl) {
              const cloned = newEl.cloneNode(true);
              cloned.style.cssText = oldEl.style.cssText;

              if (cloned.tagName === "IMG") {
                if (cloned.src !== oldEl.src) {
                  const img = new Image();
                  img.onload = () => {
                    cloned.width = oldEl.width || img.width;
                    cloned.height = oldEl.height || img.height;
                  };
                  img.src = cloned.src;
                } else {
                  cloned.width = oldEl.width;
                  cloned.height = oldEl.height;
                }
              }

              if (oldEl.scrollHeight > oldEl.clientHeight) {
                const scrollTop = oldEl.scrollTop;
                requestAnimationFrame(() => (cloned.scrollTop = scrollTop));
              }

              return cloned;
            }

            function _bindDynamicEvents(root) {
              that.initPopVariant();
              // 【修复】DOM更新后重新初始化Swiper，确保图片重新渲染后能正常滑动
              that.initProductSwiper(); 
            }
          }

          initPopQuantity() {
            const that = this;
            $(that.pfac_content).off("click", ".pfac_qty_btn");
            $(that.pfac_content).on("click", ".pfac_qty_btn", function () {
              if ($(this).hasClass("disabled")) return false;

              let $wrapper = $(this).closest(".pfac_qty_wrapper");
              let $numEl = $wrapper.find(".pfac_num");
              let $minusBtn = $wrapper.find(".pfac_minus");

              let _num = parseInt($numEl.text().trim());
              let _type = $(this).attr("data-type");

              if (_type === "minus") {
                if (_num > 1) {
                  _num = --_num;
                  $numEl.text(_num);
                  if (_num === 1) {
                    $(this).addClass("disabled");
                  } else {
                    $(this).removeClass("disabled");
                  }
                } else {
                  return false;
                }
              } else {
                _num = ++_num;
                $numEl.text(_num);
                $minusBtn.removeClass("disabled");
              }
            });
          }

          closePop(){
            const that = this;
            $(that.pfac_content)
              .removeClass("animate__fadeInUp animate__fadeOutDown")
              .addClass("animate__fadeOutDown");
            clearTimeout(that.closeTimer);
            that.closeTimer = setTimeout(function () {
              $(that.pfac_mask).fadeOut();
            }, 800); // 建议稍微加一点延迟匹配CSS动画时长
          }

          initPopListener() {
            const that = this;
            $(this).find(".pfac_content").on("click", function (e) {
              e.stopPropagation();
            });

            $(".pfac_mask").on("click", function () {
              that.closePop();
            });

            $(that.pfac_content).off("click", ".pfac_content_close");
            $(that.pfac_content).on("click", ".pfac_content_close", function () {
                that.closePop();
            });

            $(".pfac_float_btn").on("click", function () {
              $(that.pfac_mask).fadeIn();
              that.initContentPadding();
              $(that.pfac_content)
                .removeClass("animate__fadeInUp animate__fadeOutDown")
                .addClass("animate__fadeInUp");

              if ((that.pfacSwiper)) {
                if((that.autoPlayTimer)){
                  clearTimeout(that.autoPlayTimer);
                  that.autoPlayTimer = null;
                }
                that.autoPlayTimer = setTimeout(function(){
                  that.pfacSwiper.autoplay.stop();
                  that.pfacSwiper.autoplay.start();
                },3000)
              }
            });
          }

          initContentPadding() {}

          initState() {
            const element = document.querySelector(".pfac_visable");
            if(element){
                const rect = element.getBoundingClientRect();
                const bottomToViewportTop = rect.bottom;
                if (bottomToViewportTop < 0) {
                  this.showFloatAddCart();
                }
            }
          }

          initScrollListener() {
            const that = this;
            const targetElement = document.querySelector(".pfac_visable");
            if(!targetElement) return;

            let lastScrollY = window.scrollY;
            let isScrollingDown = false;

            window.addEventListener("scroll", () => {
              const currentScrollY = window.scrollY;
              isScrollingDown = currentScrollY > lastScrollY;
              lastScrollY = currentScrollY;
            });

            const observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (isScrollingDown && !entry.isIntersecting) {
                    that.showFloatAddCart();
                  } else if (!isScrollingDown && entry.isIntersecting) {
                    that.hideFloatAddCart();
                  }
                });
              },
              { threshold: 0 }
            );

            observer.observe(targetElement);
          }

          hideFloatAddCart() {
            if (this.position == "top") {
              $(".pfac_float_btn_content")
                .removeClass("animate__fadeInDown animate__fadeInUp animate__fadeOutDown animate__fadeOutUp")
                .addClass("animate__fadeOutUp");
            } else {
              $(".pfac_float_btn_content")
                .removeClass("animate__fadeInDown animate__fadeInUp animate__fadeOutDown animate__fadeOutUp")
                .addClass("animate__fadeOutDown");
            }
          }

          showFloatAddCart() {
            if (this.position == "top") {
              const element = document.querySelector(".section-header");
              if(element){
                  const rect = element.getBoundingClientRect();
                  const bottomToViewportTop = rect.bottom;
                  if (bottomToViewportTop > 0) {
                    $(".pfac_float_btn_content").css("top", `${bottomToViewportTop}px`);
                  } else {
                    $(".pfac_float_btn_content").css("top", "0");
                  }
              }
              $(".pfac_float_btn_content")
                .removeClass("animate__fadeInDown animate__fadeInUp animate__fadeOutDown animate__fadeOutUp")
                .addClass("animate__fadeInDown");
            } else {
              $(".pfac_float_btn_content").css("bottom", "0");
              $(".pfac_float_btn_content")
                .removeClass("animate__fadeInDown animate__fadeInUp animate__fadeOutDown animate__fadeOutUp")
                .addClass("animate__fadeInUp");
            }
          }
        }
      );
    }
  }
});